import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoGiaoNhanVien,
  updateDataSearch,
} from "../../../../actions/DuNoGiaoNhanVien";

export const SearchBarDesktop = ({}) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchDuNoGiaoNhanVien);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const loadTaiSan = () => {
    getListDuNoGiaoNhanVien(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang
  const onSearch = () => {
    dataSearch.pageIndex = 1;
    dispatch(getListDuNoGiaoNhanVien(dataSearch));
    loadTaiSan(dataSearch);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dataSearch.pageIndex = 1;
      dispatch(getListDuNoGiaoNhanVien(dataSearch));
    }
  }; //sự kiện tìm kiếm enter
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <input
            type="email"
            className="form-control input-sm"
            value={dataSearch.tenNhanVien}
            onChange={updateTextValue("tenNhanVien")}
            onKeyDown={handleKeyDown}
            placeholder="Tên nhân viên, SĐT"
          />
        </div>

        <div className="input-sm-new input-new-18 search-main-new">
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
